<div class="dynamic-overlay-form" [id]="'modal-' + overlayData()?.id">
  <!-- Header -->
  <div class="dynamic-heading-content" (click)="onSectionClicked($event)">
    <h1 class="dynamic-overlay-header">{{ overlayData()?.headerText }}</h1>

    <img
      class="dynamic-overlay-close-icon"
      (click)="myOverlayRef.close(true)"
      [src]="overlayData()?.closeIcon"
    />
  </div>

  <div class="dynamic-overlay-content" (click)="onSectionClicked($event)">
    <p class="modal-body-text">{{ overlayData()?.bodyText }}</p>
  </div>
</div>
